import { supabase } from '../supabase';

interface EmailLogData {
  recipient_email: string;
  sender_email: string;
  label: string;
  status: 'success' | 'failure';
  task_id?: number;
}

export const createEmailLog = async (emailLogData: EmailLogData) => {
  try {
    const { data, error } = await supabase
      .from('email_logs')
      .insert(emailLogData)
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error creating email log:', error);
    throw new Error('Failed to create email log');
  }
};
